import React, { useState, useEffect, useRef, useImperativeHandle } from "react";
import es_ES from "rsuite/locales/es_ES";
import { Plus, X, RefreshCw  } from "lucide-react";
import {
  Modal,
  Input,
  SelectPicker,
  toaster,
  CustomProvider,
  DatePicker,
  NumberInput,
  Panel,
  Message,
} from "rsuite";
import { notification } from "antd";
import {
  getHorarios,
  getTelefonoXID,
  saveUpdateCita,
  getPacienteXNombre,
  getListaPacientes,
} from "../Entities/Services/ConsultasServices";
import moment from "moment/moment";

export const ModalCita = ({
  idNegocio,
  tipoHorario,
  nomPaciente,
  onSubmit,
  idUser,
  ref,
}) => {
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [fechaHoy] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.fechas,
  );
  const [api, contextHolder] = notification.useNotification();
  const [messageConfirm, setMessageConfirm] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.msjConfirm,
  );
  const [isOpen, setIsOpen] = useState(false);
  const initialized = useRef(false);
  const [disableBtn, setDisableBtn] = useState(true);

  // States
  const [dataPaciente, setDataPaciente] = useState([]);
  const [fechaHorario, setFechaHorario] = useState("");

  const [horario, setHorario] = useState("");
  const [espacio, setEspacio] = useState(0);
  const [idPaciente, setIdPaciente] = useState(0);
  const [disableHors, setDisableHors] = useState(true);
  const [nuevaFecha, setNuevaFecha] = useState("");
  const [horaIni, setHoraIni] = useState("");
  const [showListaPac, setSowListaPac] = useState(true);
  const [horNvaCita, setHorNvaCita] = useState("");
  const [dataHorarios, setDataHorarios] = useState([]);
  const [fecha, setFecha] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [nuevaCita] = useState(true);

  const [open, setOpen] = useState(false);

  const [listaPacientes, setListaPacientes] = useState([
    { label: "+ NUEVO PACIENTE", value: "-1" },
  ]);

  const [paciente, setPaciente] = useState(nomPaciente);
  const [telefono, setTelefono] = useState("");
  const [nuevoPac, setNuevoPac] = useState(false);

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const maskTime = (value) => {
    setHoraIni(
      value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1:$2")
        .replace(/(\d{2})(\d)/, "$1:$2"),
    );
  };

  const sendMessage = () => {
    var anchor = document.createElement("a");
    anchor.href = `https://api.whatsapp.com/send?phone=${telefono}&text=${messageConfirm}`;
    anchor.target = "_blank";
    anchor.click();
    setIsOpen(false);
  };

  const handleClose = () => {
    setSowListaPac(true);
    setIsOpen(false);
  };

  const handleChangeFec = (e) => {
    if (e != null) {
      var fecha = new Date(e).toISOString();
      setDisableHors(false);
      setFecha(e);
      fetchHorarios(fecha);
    } else {
      setDataHorarios([]);
    }
  };

  const handleChangeTelefono = async (value) => {
    setTelefono(value);
  };

  const handleNuevoNombre = async (e) => {
    if (!e) {
      setDisableBtn(true);
      setPaciente("");
    } else {
      setDisableBtn(false);
      setPaciente(e);
    }
  };

  const hanldeNombrePaciente = async (e) => {
    if (e === null) {
      setIdPaciente("0");
      setSowListaPac(true);
      setPaciente("");
      setNuevoPac(true);
      setTelefono("");
      return;
    }

    if (e === "-1") {
      setIdPaciente("0");
      setSowListaPac(false);
      setPaciente("");
      setNuevoPac(true);
      setTelefono("");
      return;
    }

    const _idPac = e;
    const ID = _idPac.split("-")[0];

    setIdPaciente(e);
    const selectedItem = listaPacientes.find((item) => item.value === e);
    setPaciente(selectedItem.label);

    const res = await getTelefonoXID(idNegocio, ID, selectedItem.label);
    if (!res) {
      setTelefono("");
    }
    if (res.telefono === undefined) {
      return;
    }

    setTelefono(res.telefono);
  };

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  const fetchHorarios = async (fecha) => {
    await getHorarios(idNegocio, fecha).then((nxt) => {
      setFechaHorario(fecha);
      setDataHorarios(nxt);
    });
  };

  const handleHorario = (e) => {
    if (e === null) {
      setNuevaFecha("");
      setHorario("");
      setDisableBtn(true);
    } else {
      setNuevaFecha(e);
      setHorario(e);
      setDisableBtn(false);
      const _hor = e.substring(0, 5);
      const _fec = moment(fechaHorario).format("DD/MM/YYYY");
    }
  };

  const getPacientePorNombre = async (nombre) => {
    const response = await getPacienteXNombre(idNegocio);
    setDataPaciente(response);
  };

  const handleNewCita = async () => {
    setListaPacientes([{ label: "+ NUEVO PACIENTE", value: "-1" }]);
    setSowListaPac(true);
    setIdPaciente("");
    setHorario("");
    setHorNvaCita("");
    setTelefono("");
    setPaciente("");
    setHoraIni("");
    setFecha(moment(fechaHoy).format("YYYY-MM-DD"));
    setNuevaFecha(moment(fechaHoy).format("YYYY-MM-DD"));
    setNuevoPac(true);

    await getListaPacientes(idNegocio).then((res) => {
      setListaPacientes((prev) => [...prev, ...res]);
    });
  };

  const save = async () => {
    try {
      if (telefono.length < 10) {
        toast("Debes colocar un numero teléfóno.", "error");
        return;
      }

      if (!paciente && nuevoPac) {
        toast("El nombre no puede estar vacio", "error");
        return;
      }

      if (tipoHorario === "horarioLibre" && !horaIni) {
        toast("El horario no puede estar vacio", "error");
        return;
      }

      setIsLoading(true);

      const _idPac = idPaciente;
      const ID = _idPac.split("-")[0];

      const dataCita = {
        id: idNegocio,
        idPaciente: ID,
        espacio: espacio,
        fechaAnterior:
          fecha !== "" ? moment(fecha).format("DD-MM-YYYY") : fecha,
        fecha: fecha !== "" ? moment(fecha).format("DD-MM-YYYY") : fecha,
        hora: tipoHorario === "horarioLibre" ? horaIni : horario,
        nombre: paciente,
        telefono: telefono,
        correo: "",
        domicilio: "",
        edoMun: "",
        descripCita: "",
        nuevaCita: nuevaCita,
        tipoHorario: tipoHorario,
      };

      // console.log(dataCita);
      const res = await saveUpdateCita(dataCita);
      if (res.data === -1) {
        toast("El horario no se encuentra disponible.", "warning");
        setIsLoading(false);
        return;
      }
      if (res.data === -2) {
        toast(
          "La cita no puede ser re-programada ya se ha realizado.",
          "warning",
        );
        setIsLoading(false);
        return;
      }

      if (res.data === -3) {
        toast(
          "La cita no puede ser programada el horario esta ocupado.",
          "warning",
        );
        setIsLoading(false);
        return;
      }

      toast("Se actualizo la cita de forma correcta", "success");

      setTimeout(() => {
				setIsLoading(false);
        window.location.reload();
      }, [1000]);
    } catch (error) {
      toast(error.message, "error");
      setIsLoading(false);
    }
  };

  useImperativeHandle(
    ref,
    () => ({
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
      toggle: () => setIsOpen((_) => !_),
    }),
    [],
  );

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      handleNewCita();
    }
  }, []);


  return (
    <div>
      {contextHolder}
      {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE EDICION PARA HORARIO Y NUEVA CITA O RE-PROG <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
      <Modal
        size="md"
        open={isOpen}
        onClose={handleClose}
        backdrop="static"
        overflow="false"
      >
        <Modal.Header>
          <Modal.Title>Nueva Cita</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel bordered>
            <div className="row mb-1">
              <div className="col-lg-8 col-md-8 col-sm-8">
                <b>Nombre</b>
                <span style={{ color: "red", fontSize: "12px" }}>
                  &nbsp; * Obligatorio
                </span>
                {showListaPac ? (
                  <SelectPicker
                    key={`pickerPacientes`}
                    width={"100%"}
                    data={listaPacientes}
                    value={idPaciente}
                    onChange={(e) => hanldeNombrePaciente(e)}
                    searchable
                    placeholder="Selecciona un paciente..."
                    block
                  />
                ) : !nuevoPac ? (
                  <Input readOnly value={paciente} />
                ) : (
                  <Input
                    defaultValue={nomPaciente}
                    style={{ borderRadius: "15px" }}
                    value={paciente}
                    onChange={(e) => handleNuevoNombre(e)}
                  />
                )}
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4">
                <b>Teléfono</b>
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                  }}
                >
                  &nbsp; * Obligatorio
                </span>
                <NumberInput
                  controls={false}
                  value={telefono}
                  onChange={(e) => handleChangeTelefono(e)}
                  style={{ borderRadius: "15px", textAlign: "center" }}
                  maxLength={10}
                  min={0}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6 col-md-6 col-sm-6">
                <b>Fecha</b>
                {tipoHorario === "horarioDisp" ? (
                  <Input
                    readOnly
                    value={moment(fechaHoy).format("DD/MM/YYYY")}
                    style={{ textAlign: "center", borderRadius: "15px" }}
                  />
                ) : tipoHorario === "Reprog" ||
                  tipoHorario === "horarioLibre" ? (
                  <CustomProvider locale={es_ES}>
                    <DatePicker
                      block
                      shouldDisableDate={handleDisabledDate}
                      onChange={(e) => handleChangeFec(e)}
                    />
                  </CustomProvider>
                ) : (
                  <Input
                    readOnly
                    value={nuevaFecha}
                    style={{ textAlign: "center", borderRadius: "15px" }}
                  />
                )}
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6">
                <b>Horario</b>
                {tipoHorario === "horarioDisp" ? (
                  <Input
                    readOnly
                    value={horNvaCita}
                    defaultValue={horNvaCita}
                    style={{ textAlign: "center", borderRadius: "15px" }}
                  />
                ) : tipoHorario === "Reprog" ? (
                  <SelectPicker
                    style={{ width: "auto" }}
                    block
                    searchable={false}
                    data={dataHorarios}
                    disabled={disableHors}
                    onChange={(e) => handleHorario(e)}
                    placeholder="Selecciona un horario"
                  />
                ) : (
                  <Input
                    placeholder="00:00"
                    maxLength={5}
                    value={horaIni}
                    onChange={(e) => maskTime(e)}
                    style={{ textAlign: "center", borderRadius: "15px" }}
                  />
                )}
              </div>
            </div>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          
          <button
            type="button"
            onClick={handleClose}
            className="w-50 px-4 py-2 bg-slate-100 text-sm font-semibold text-slate-600 hover:bg-slate-300 rounded-xl transition-colors"
          >
            Cancelar
          </button>

          <button
            type="button"
            onClick={save}
            disabled={isLoading}
            className="w-50 px-4 py-2 text-xs font-semibold flex items-center justify-center gap-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-xl transition-colors shadow-md shadow-cyan-600/20"
          >
            {isLoading ? (
              <>
                <RefreshCw className="w-4 h-4 animate-spin" /> Guardando...
              </>
            ) : (
              <>
                Guardar cita
              </>
            )}
          </button>
          
        </Modal.Footer>
      </Modal>
    </div>
  );
};
